import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CircularProgress, ClickAwayListener, Divider, Grid, Grow, ListItemIcon, ListItemText, MenuItem, MenuList, Paper, Popper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import Backdrop from '../../../components/Modal/Backdrop';
import Modal from '../../../components/Modal/Modal';
import { useStyles } from './styles'
import axiosInstance from '../../../environment/axiosInstance'
// import ArticlesTableBody from './ArticlesTableBody';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';
import { Link } from 'react-router-dom';
import Switch from "react-switch";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Communities() {
    const classes = useStyles();
    const [openExpand, setOpenExpand] = React.useState(true);
    const tableHeader = ['Name', 'phoneNumber', 'phoneName', 'Mac Address', 'staus',];
    const [loading, setLoading] = React.useState(false);
    const [articles, setArticles] = React.useState([]);
    const [settings, setSettings] = useState(null);
    const [search, setSearch] = useState("");
    const [communityEnabled, setCommunityEnabled] = useState(false);

    const expandOpen = () => {
        setOpenExpand(!openExpand)
    }

    //api integration
    const fetchSettings = () => {
        var local_user = localStorage.getItem("user_data")
        var current_user = local_user ? JSON.parse(local_user) : {}
        const token = Object.keys(current_user).length && current_user?.tokenData?.access ? current_user?.tokenData?.access?.token : null;
        setLoading(true)
        axiosInstance.get('/support/business_owner/settings', {
            headers: {
                "Authorization": "Bearer " + token
            }
        }).then((res: any) => {
            // console.log('desk', res)
            if (res.status === 200) {
                setLoading(false);
                setSettings(res.data.Data);
                setCommunityEnabled(res.data.Data?.community_enabled);
            }

        }).catch((err: any) => {
            console.log(err);
        });
    }

    React.useEffect(() => {
        fetchSettings()
    }, []);

    const handleCommunitySwitchChanged = (checked: any) => {
        setCommunityEnabled(checked);

        var local_user = localStorage.getItem("user_data")
        var current_user = local_user ? JSON.parse(local_user) : {}
        const token = Object.keys(current_user).length && current_user?.tokenData?.access ? current_user?.tokenData?.access?.token : null;
        axiosInstance.post('/support/business_owner/settings/save', {
            community_enabled: checked
        }, {
            headers: {
                "Authorization": "Bearer " + token
            }
        }).then((res: any) => {
            // console.log('desk', res)
            if (res.status === 200) {
                toast.success(res.data.message)
            }

        }).catch((err: any) => {
            console.log(err);
        });
    }

    return (
        <div>
            <ToastContainer />
            <div>
                <label style={{
                    display: "flex",
                    alignItems: "center"
                }}>
                    <span>Enable / Disable community&nbsp;</span>
                    <Switch
                        onChange={handleCommunitySwitchChanged}
                        checked={communityEnabled}
                        height={18}
                        width={40}
                    />
                </label>
            </div>
            <Card className={classes.card}>
                {/* <Accordion expanded={openExpand}
                    onChange={expandOpen}>
                    <AccordionSummary
                        expandIcon={openExpand ? <FiMinusCircle color="#2645ad" onClick={expandOpen} /> : <FiPlusCircle color="#2645ad" onClick={expandOpen} />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>My Articles</Typography>
                    </AccordionSummary>
                    <Divider className={classes.divider} />
                    <div className={classes.cardBody}>
                        <Grid container spacing={2}>
                            <Grid item md={4}>
                            </Grid>
                            <Grid item md={2}></Grid>
                            <Grid item md={6}>
                                <Link
                                    to="/dashboard/articles/add"
                                    className={classes.gridItem + " " + classes.addArticleLink}
                                >
                                    Add Article
                                </Link>
                            </Grid>
                        </Grid>
                        <Card className={classes.cardStyles}>
                            <TableContainer>
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableName}>Sr. #</TableCell>
                                            <TableCell className={classes.tableName}>Title</TableCell>
                                            <TableCell className={classes.tableName}>Status</TableCell>
                                            <TableCell className={classes.tableName}>Action</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loading ?
                                            <Box>
                                                <div style={{ position: "absolute", width: "100%", textAlign: "center" }}>
                                                    <CircularProgress />
                                                </div>
                                            </Box> 
                                            :
                                            articles.length > 0 && (
                                                articles.filter((itm: any) => itm.title.toLowerCase().includes(search.toLowerCase()))
                                                    .map((roomData, i) => <ArticlesTableBody
                                                        roomData={roomData}
                                                        articles={articles}
                                                        i={i}
                                                        fetchArticles={fetchArticles}
                                                    />
                                                    )
                                            )
                                        }
                                    </TableBody>
                                </Table>
                                {
                                    articles?.length <= 0 && <p style={{ textAlign: 'center', padding: 10 }}>No articles found</p>
                                }
                            </TableContainer>
                        </Card>
                    </div>
                </Accordion> */}
            </Card>
        </div>
    )
}

export default Communities;